import * as S from "./styles.ts";
import { Form, UniversalLink } from "@template/components";
import { useState } from "react";

export const WebinarForm = () => {
  const [webinarFormValue, setWebinarFormValue] = useState<
    Record<string, string>
  >({
    w_name: "",
    w_email: "",
    confirmEmail: "",
  });
  const [errors, setErrors] =
    useState<Record<string, string>>(webinarFormValue);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const handleCheckboxChange = () => {
    setChecked(!checked);
  };

  const submitForm = async (data: Record<"w_name" | "w_email", string>) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("w_name", data.w_name);
      formData.append("w_email", data.w_email);

      const res = await fetch("https://www.yay.com/webinar/", {
        method: "POST",
        body: formData,
      });
      const response = await res.json();
      setSuccessMessage("Yay! Your attendance is confirmed.");
      setWebinarFormValue({
        w_name: "",
        w_email: "",
        confirmEmail: "",
      });
    } catch (error) {
      console.error(error);
      setAlertMessage("An error occurred, please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (data: Record<string, any>) => {
    await submitForm(data);
  };

  return (
    <div>
      <Form
        submit={{
          text: "Register to Attend",
          onSubmit: handleSubmit,
          loading: loading,
        }}
        inputs={[
          {
            label: "Full Name",
            name: "w_name",
            error: errors.name,
            span: 12,
            required: true,
            validation: {
              regex: /^[a-zA-Z\s]*$/,
              error: "Please enter a valid name",
            },
          },
          {
            label: "Email",
            name: "w_email",
            placeholder: "name@example.com",
            validation: {
              regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              error: "Please enter a valid email address",
            },
            error: errors.email,
            span: 12,
            required: true,
          },
          {
            label: "Confirm Email",
            name: "confirmEmail",
            placeholder: "name@example.com",
            validation: {
              custom: (val: string, e?: any) =>
                val === e?.target?.form?.w_email?.value,
              error: "Email adresses do not match",
            },
            error: errors.confirmEmail,
            span: 12,
            required: true,
          },
        ]}
        checkbox={{
          name: "Privacy policy",
          label: (
            <>
              You agree to our friendly{" "}
              <UniversalLink
                styled
                href="/about/privacy"
              >
                Privacy Policy
              </UniversalLink>
            </>
          ),
          checked: checked,
          onChange: handleCheckboxChange,
        }}
      />
      <S.Alert>{alertMessage}</S.Alert>
      <S.Success>{successMessage}</S.Success>
    </div>
  );
};
